import api from '@/plugins/apiService'

export default {
  namespaced: true,
  state: {
    paymentMethods: [],
    calucalteMethods: [],
    addPaymentsMethods: [],
    aiRquestMethods: [],
    draftAIMethods: [],
    addChargeMethods: [],
    requestsTableMethods: [],
    savedDraftsMethods: [],
    updateDraftMethods: [],
  },
  getters: {
    GET_PAYMENT_METHODS: state => state.paymentMethods,
    GET_CALCULATE_METHODS: state => state.calucalteMethods,
    GET_ADD_PAYMENTS_METHODS: state => state.addPaymentsMethods,
    GET_AI_METHODS: state => state.addPaymentsMethods,
    GET_DRAFT_AI_METHODS: state => state.draftAIMethods,
    GET_CHARGE_METHOD: state => state.addChargeMethods,
    GET_TABLE_REQUESTS_TABLE: state => state.requestsTableMethods,
    GET_SAVED_DRAFT_MESSAGE: state => state.savedDraftsMethods,
    GET_UPDATE_DRAFT_MESSAGE: state => state.updateDraftMethods,
  },
  mutations: {
    SET_PAYMENT_METHODS: (state, payload) => {
      state.paymentMethods = payload
    },
    SET_CALCULATE_METHODS: (state, payload) => {
      state.calucalteMethods = payload
    },
    SET_ADD_PAYMENT_METHODS: (state, payload) => {
      state.addPaymentsMethods = payload
    },
    SET_AI_REQUEST_METHODS: (state, payload) => {
      state.aiRquestMethods = payload
    },
    SET_SAVED_DARFT_AI_REQUEST: (state, payload) => {
      state.savedDraftsMethods = payload
    },
    SET_UPDATE_DARFT_AI_REQUEST: (state, payload) => {
      state.updateDraftMethods = payload
    },
    SET_REQUEST_TABLE_METHODS: (state, payload) => {
      state.requestsTableMethods = payload
    },
    SET_DRAFT_AI_REQUEST_METHODS: (state, payload) => {
      state.aiRquestMethods = payload
    },
    SET_ADD_CHARGE_METHODS: (state, payload) => {
      state.addChargeMethods = payload
    },
  },
  actions: {
    async FETCH_PAYMENT_METHODS({ commit }) {
      try {
        const { data } = await api.findAll('payment/payment-method-list')
        if (data.success) {
          commit('SET_PAYMENT_METHODS', data.data)
          return data
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error)
      }
    },
    async ADD_PAYMENT_METHOD({ commit }, payload) {
      try {
        const { data } = await api.save('payment/add-payment-method', payload)
        if (data.success) {
          commit('SET_ADD_PAYMENT_METHODS', data.data)
          return data
        }
      } catch (error) {
        console.error('Error in ADD_PAYMENT_METHOD:', error)
      }
    },

    async ADD_AI_REQUEST({ commit }, payload) {
      const obj = {
        workdrive_id: payload.workdrive_id,
        notes: payload.notes,
        pages: payload.pages,
      }
      try {
        const { data } = await api.save(`estimations/${payload.estimation_id}/ai-request`, obj)
        if (data.success) {
          commit('SET_ADD_PAYMENT_METHODS', data.data)
          return data
        }
      } catch (error) {
        console.error('Error in ADD_PAYMENT_METHOD:', error)
      }
    },

    async ADD_CHARGE_METHOD({ commit }, payload) {
      const obj = {
        paymentMethodId: payload.paymentMethodId,
        amount: payload.amount,
        request_id: payload.request_id,
      }
      try {
        const { data } = await api.save(
          `payment/charge-payment/?request_id=${payload.request_id}`,
          obj,
        )
        if (data.success) {
          commit('SET_ADD_CHARGE_METHODS', data.data)
          return data
        }
      } catch (error) {
        console.error('Error in ADD_PAYMENT_METHOD:', error)
      }
    },

    async FETCH_CALCULATE_CHARGE({ commit }, pages) {
      try {
        const { data } = await api.findAll(`payment/calculate-charge?pages=${pages}`)
        if (data.success) {
          commit('SET_CALCULATE_METHODS', data.data)
          return data
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error)
      }
    },

    async FETCH_AI_REQUESTS({ commit }) {
      try {
        const { data } = await api.findAll('estimations/list-draft-ai-requests')
        if (data.success) {
          commit('SET_AI_REQUEST_METHODS', data.data)
          return data
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error)
      }
    },

    async FETCH_REQUESTS_TABLE({ commit },payload) {
      try {
        const { data } = await api.findAll(`estimations/list-ai-requests?page=${payload.page}&limit=${payload.limit}`)
        if (data.success) {
          commit('SET_REQUEST_TABLE_METHODS', data.data)
          return data
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error)
      }
    },

    async SAVED_DARFT_AI_REQUEST({ commit }, payload) {
      try {
        const { data } = await api.update('estimations/draft-ai-request', payload)
        if (data.success) {
          commit('SET_SAVED_DARFT_AI_REQUEST', data.data)
          return data
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error)
      }
    },

    async UPDATE_DARFT_AI_REQUEST({ commit }, payload) {
      const obj = {
        notes: payload.notes,
      }
      try {
        const { data } = await api.update(`estimations/ai-request/${payload.uuid}`, obj)
        if (data.success) {
          commit('SET_UPDATE_DARFT_AI_REQUEST', data.data)
          return data
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error)
      }
    },
    async UPDATE_DARFT_REQUEST_STATUS({ commit }, payload) {
      const obj = {
        workdrive_id: payload.workdrive_id,
        notes: payload.notes,
        pages: payload.pages,
        request_status: 'Pending',
        estimation_id: payload.estimation_id,
      }
      try {
        const { data } = await api.update(`estimations/ai-request/${payload.uuid}`, obj)
        if (data.success) {
          commit('SET_UPDATE_DARFT_AI_REQUEST', data.data)
          return data
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error)
      }
    },
    async COMPLETE_AI_ESTIMATION_REQUEST({ commit }, payload) {
      try {
        const { data } = await api.update(`ac-api/complete-estimation-ai-req/?request_id=${payload.request_id}&tenant_id=${payload.tenant_id}`)
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error)
      }
    },
  },
}
